import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { dispatch, connect } from "../recontext/store";
import { api } from "../services/index";
import Loading from "./Loading";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  }
});

class TeamDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleClickSubmit = this.handleClickSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      loading: false,
      myTeam: null,
      name: "",
      intro: "",
      track: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    const { updateTeamDialogVisible } = this.props;
    if (nextProps.updateTeamDialogVisible && !updateTeamDialogVisible) {
      const { user, teams } = this.props;
      const myTeam = teams[user.id];
      this.setState({
        myTeam: myTeam,
        name: myTeam.name || "",
        intro: myTeam.intro || "",
        track: myTeam.track || ""
      });
    }
  }

  handleClose() {
    this.setState({
      loading: false,
      name: "",
      intro: "",
      track: ""
    });
    dispatch("HIDE_UPDATE_TEAM_DIALOG");
  }

  async handleClickSubmit(event) {
    event.preventDefault();
    this.setState({
      loading: true
    });
    const { myTeam, name, intro, track } = this.state;
    await api.updateTeamInfo(myTeam, { name, intro, track });
    this.handleClose();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    const { updateTeamDialogVisible } = this.props;
    const { loading, name, intro, track } = this.state;

    return (
      <Dialog
        open={updateTeamDialogVisible}
        disableBackdropClick={true}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={this.handleClickSubmit}>
          <DialogTitle id="form-dialog-title">Update Team</DialogTitle>
          <DialogContent>
            <DialogContentText>Fillup your team info</DialogContentText>
            <TextField
              required
              autoFocus
              margin="dense"
              id="name"
              name="name"
              label="Team Name"
              value={name}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              required
              margin="dense"
              id="intro"
              name="intro"
              label="Intro"
              value={intro}
              onChange={this.handleChange}
              fullWidth
            />
            <FormControl required fullWidth margin="dense">
              <InputLabel htmlFor="track">Track</InputLabel>
              <Select
                value={track}
                onChange={this.handleChange}
                inputProps={{
                  name: "track",
                  id: "track"
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"BlockChain"}>
                  Loyalty program with blockchain
                </MenuItem>
                <MenuItem value={"FinTech"}>Fun finance application</MenuItem>
                <MenuItem value={"BigData"}>Prediction with big data</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button type="submit" color="primary">
              Update
            </Button>
          </DialogActions>
        </form>
        <Loading visible={loading} />
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  teams: state.teams,
  updateTeamDialogVisible: state.updateTeamDialogVisible
});

export default connect(mapStateToProps)(withStyles(styles)(TeamDialog));
